<template>
  <div class="desktop-top-nav">
    <div class="d-flex flex-wrap justify-end align-center">
      <v-menu
        :close-on-content-click="false"
        open-on-hover
        offset-y
        transition="slide-y-transition"
        bottom
        content-class="dropdown-top"
        v-for="hirKategoria in hirKategoriak"
        :key="hirKategoria.Id"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            {{ hirKategoria.Nev }}
            <v-icon class="ml-2">fa-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-sheet>
          <v-list dense>
            <v-list-item
              v-for="alkategoria in hirKategoria.Kategoria"
              :key="alkategoria.Id"
              exact
              replace
              :to="{
                name: 'Fooldal',
                query: {
                  alkategoriaId: alkategoria.Id,
                },
              }"
            >
              <v-list-item-content>
                <v-list-item-subtitle>
                  {{ alkategoria.Nev }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
      </v-menu>
    </div>

    <v-menu
      v-if="userBelepve"
      :close-on-content-click="false"
      open-on-hover
      offset-y
      transition="slide-y-transition"
      bottom
      content-class="dropdown-top"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on">
          Profil
          <v-icon class="ml-2">fa-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-sheet>
        <v-list class="link-list" dense>
          <v-list-item
            v-for="menupont in menuk"
            :key="menupont.title"
            :to="menupont.to"
            @click="menupont.action"
          >
            <v-list-item-content>
              <v-list-item-subtitle>
                {{ menupont.title }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-sheet>
    </v-menu>

    <v-list
      class="py-0 link-list"
      dense
      v-if="!userBelepve && aktualisProjekt && aktualisProjekt.BelepesGombFl"
    >
      <v-list-item class="px-2" @click="OpenLoginModal" link>
        <v-icon class="fa-fw mr-2 font-size-sm">
          fa-sign-in-alt
        </v-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ nyelvesites['belepek_text'] }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-list
      class="py-0 link-list"
      dense
      v-if="userBelepve && linkek.length > 0"
    >
      <v-list-item class="px-4" @click.stop="ToggleDrawer">
        <v-icon class="font-size-lg primary-icon">
          fas fa-bars
        </v-icon>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../../functions/AppFunctions';
import { userService } from '../../services/UserService';
import settings from '../../settings';
import { AppStoreTypes } from '../../store/modules/app';
import { modalHandler } from '../../utils/vue/modalHandler';
export default {
  name: 'k-desktop-top-menu',
  data() {
    return {
      isBv: settings.env == 'bv',
      menuk: [
        {
          to: '/fontosak/',
          title: 'Fontosak',
          icon: 'fas fa-bookmark',
          action: () => {},
        },
        {
          to: '/elozmenyek/',
          title: 'Előzmények',
          icon: 'fas fa-clipboard-list',
          action: () => {},
        },
        {
          to: '/profil/',
          title: 'Profil adatok szerkesztése',
          icon: 'fas fa-user',
          action: () => {},
        },
        {
          to: null,
          title: 'Kijelentkezés',
          icon: 'fas fa-sign-out-alt',
          action: this.Logout,
        },
      ],
    };
  },
  mounted() {},
  created() {},
  methods: {
    OpenLoginModal() {
      modalHandler.OpenModal('login-modal', null, { maxWidth: '400px' });
      this.drawer = false;
    },
    ToggleDrawer() {
      this.drawer = !this.drawer;
    },
    async Logout() {
      if (global.SNJS && global.SNJS.logout) {
        global.SNJS.logout();
      }
      await userService.Embed({ apiKey: this.aktualisProjekt.ApiKulcs });
      if (this.$route.name != 'Fooldal') {
        this.$router.push({ name: 'Fooldal' });
      }
    },
  },
  computed: {
    ...mapGetters({
      hirKategoriak: AppStoreTypes.hirKategoriak.getAll,
      user: AppStoreTypes.user.get,
      linkek: AppStoreTypes.linkek.getAll,
    }),
    aktualisProjekt() {
      return this.user?.Projekt;
    },
    userBelepve() {
      return this.user?.Id > 0;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    drawer: {
      get() {
        return this.$store.getters[AppStoreTypes.isDrawerOpened.get];
      },
      set(value) {
        this.$store.dispatch(AppStoreTypes.isDrawerOpened.set, { value });
      },
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {},
  components: {},
};
</script>
